import type { TweetCreateRequestMetadataContent } from './tweetCreateRequestMetadataContent';
import type { TweetCreateRequestMetadataPoll } from './tweetCreateRequestMetadataPoll';
import type { TweetCreateRequestMetadataTags } from './tweetCreateRequestMetadataTags';
import type { TweetCreateRequestMetadataTweetType } from './tweetCreateRequestMetadataTweetType';

export interface TweetCreateRequestMetadata {
  /** 트윗 내용 정보 */
  content: TweetCreateRequestMetadataContent;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: TweetCreateRequestMetadataPoll;
  /** 참조 트윗 ID (답글, 인용, 리트윗인 경우) */
  referencedTweetId?: string;
  /** 트윗 태그 정보 */
  tags?: TweetCreateRequestMetadataTags;
  /** 트윗 유형 */
  tweetType?: TweetCreateRequestMetadataTweetType;
}
